// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import { useEffect, useState } from 'react'
import * as api from '../../api/client'
import { useAuth } from '../../auth/AuthContext'
import CommentThread from './CommentThread'

/**
 * Per-Rx comment thread. Direction (notify pharmacy vs provider) is inferred server-side
 * from the author's role. Authors can edit/delete their own comments and @-tag teammates
 * (in-app notification + email).
 */
export default function RxComments({ rxId, onAfterChange }: {
  rxId: string
  payerState?: string
  onAfterChange?: () => void
}) {
  const { me } = useAuth()
  const [items, setItems] = useState<api.RxComment[]>([])

  const load = () => {
    api.listRxComments(rxId).then(r => setItems(r.items)).catch(() => { /* best-effort */ })
    onAfterChange?.()
  }
  useEffect(() => { load() }, [rxId])

  return (
    <CommentThread
      items={items}
      currentAccountId={me?.account_id}
      headerNote="Comments notify the other side (pharmacy ↔ provider). Tag a teammate to alert them in-app and by email."
      onPost={(body, mentions) => api.createRxComment(rxId, { body, mentions }).then(() => {})}
      onEdit={(id, body, mentions) => api.editRxComment(rxId, id, body, mentions).then(() => {})}
      onDelete={(id) => api.deleteRxComment(rxId, id).then(() => {})}
      reload={load}
    />
  )
}
